import apiClient from './api';

export interface Alarm {
  id: number;
  title: string;
  message: string;
  scheduledTime: string;
  type: string;
  checked: boolean;
}

export interface UnreadCountResponse {
  count: number;
}

export const alarmService = {
  getMyAlarms: async (): Promise<Alarm[]> => {
    const response = await apiClient.get<Alarm[]>('/me/alarms');
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await apiClient.get<UnreadCountResponse>('/me/alarms/unread-count');
    return response.data.count;
  },
};
